import locale from "@/helpers/locale";
export const columnLabels = [
  {
    label: locale('global.screenStandard'),
    value: 'version'
  },
  {
    label: locale('trans.report.version.caption'),
    value:'subtitlesVersion'
  },
  {
    label: locale('global.otherVersions'),
    value:'otherVersion'
  },
  {
    label: locale('trans.box.week'),
    value:'week'
  },
  {
    label: locale('trans.box.clientName'),
    value:'clientName'
  },
  {
    label: locale('trans.box.cumulativeDevelopment'),
    value:'cumulativeDevelopment'
  }
]